export const APP_CONFIG = {
    COUNTRY_WITHOUT_ZIP: ['HK', 'MO', 'NR', 'TV', 'TK'],
    PHONE_REGEX: /^(?:\+|00)?[\d(][\d\s\-()]{6,19}$/,
    EMAIL_REGEX: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z-0-9]+\.)+[a-zA-Z]{2,}))$/,
};
